import { regexSpecialCharacters } from './stripSpecialChars';

export const normalizeAssignedCategoryPath = (path: string): string =>
    path
        .replaceAll('&', 'and')
        .replaceAll('é', 'e')
        .replaceAll('-', ' ')
        .replaceAll('–', ' ')
        .replaceAll('—', ' ')
        .replace(/\s+/g, ' ')
        .replace(regexSpecialCharacters, '')
        .trim();
